export enum TooltipContentType {
    BEST_IN_TEST = 'best-in-test',
    BEST_PRICE_GUARANTEE = 'best-price-guarantee',
    BLACK_FRIDAY_PLECTRON = 'black-friday-plectron',
    BLACK_FRIDAY_SIGNET = 'black-friday-signet',
    CANCELLATION = 'cancellation',
    CANCELLATION_SIGNET = 'cancellation-signet',
    DISCOUNT = 'discount',
    EARLY_BIRD = 'earlybird',
    EARLY_BIRD_HOLIDAYHOME = 'earlybirdHolidayhome',
    FOCUS_MONEY = 'focus-money',
    HOLIDAY_SAFETY = 'holiday-safety',
    LAST_MINUTE = 'lastminute',
    LAST_MINUTE_HOLIDAYHOME = 'lastminuteHolidayhome',
    NOWHERE_CHEAPER = 'nowhere-cheaper',
    SEM_GCAMID_VOUCHER = 'sem-gcamid-voucher',
    SERVICE_QUALITY = 'service-quality',
    STIFTUNG_WARENTEST = 'stiftung-warentest',
    TESTWINNER = 'testwinner',
    TUEV_SEAL = 'tuev-seal',
    TUEV_SERVICE = 'tuev-service',
    VOUCHER_100 = 'voucher-100',
    VOUCHER_200 = 'voucher-200',
    VOUCHER_50 = 'voucher-50',
    VOUCHER_PAYBACK_50 = 'voucher-payback-50',
}
